module.exports = __webpack_public_path__ + "static/img/hzyh1.cc613735.png";